import React from 'react';
import styled from 'styled-components';
import { CloseIcon } from '../../../assets/icons';
import Modal from '../../Modal';
import ActionButtons from './ActionButtons';
import useRiskAssessmentResult from '../hooks/use-risk-assessment-result';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  hasRisk: boolean;
}

const RiskAssessmentResultModal = ({ isOpen, onClose, hasRisk }: Props) => {
  const { bookOBVisitURL, instructionsCopy } = useRiskAssessmentResult(hasRisk);

  return (
    <Modal onRequestClose={onClose} open={isOpen}>
      <Container>
        <TopBar>
          <CloseIconButton onClick={onClose} aria-label="Close">
            <CloseIcon width={20} height={20} />
          </CloseIconButton>
        </TopBar>
        <Body>
          <Header>Thank you for your submission</Header>

          <Description>
            Your assessment helps us understand when you should come in for your initial pregnancy
            appointment.
          </Description>
          <Instructions>{instructionsCopy}</Instructions>
          <ActionButtons onCancelClick={onClose} bookOBVisitURL={bookOBVisitURL} />
        </Body>
      </Container>
    </Modal>
  );
};

export default RiskAssessmentResultModal;

const Container = styled.div`
  max-width: 580px;
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
`;

const Body = styled.div`
  padding: 0px 20px 15px 20px;

  @media ${({ theme }) => theme.queries.minTablet} {
    padding: 0px 84px 15px 84px;
  }
`;

const Header = styled.h1`
  margin-bottom: 30px;
  text-align: center;

  ${({ theme }) => theme.fonts.DomaineDisplay};
  font-size: 24px;
  line-height: 32px;

  @media ${({ theme }) => theme.queries.minTablet} {
    font-size: 28px;
    line-height: 37px;
  }
`;

const CloseIconButton = styled.button`
  padding: 10px 8px 8px 0px;
  margin-left: auto;

  svg path {
    fill: ${({ theme }) => theme.colors.night};
  }
`;

const Description = styled.p`
  margin-bottom: 23px;
  text-align: center;
  font-size: 16px;
  line-height: 20px;

  ${({ theme }) => theme.fonts.FoundersGrotesk};

  @media ${({ theme }) => theme.queries.minTablet} {
    margin-bottom: 32px;
  }
`;

const Instructions = styled.p`
  margin-bottom: 15px;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;

  ${({ theme }) => theme.fonts.FoundersGrotesk};
`;
